/* __next_internal_client_entry_do_not_use__ LoginSection auto */ import { jsx as _jsx } from "react/jsx-runtime";
import { useIsLoggedInRetailer } from "@faire/retailer-visitor-shared/lib/isLoggedInRetailer";
import React from "react";
import { LoggedInLoginSection } from "./LoggedIn";
import { LoggedOutLoginSection } from "./LoggedOut";
export var LoginSection = /*#__PURE__*/ React.memo(function() {
    var isLoggedInRetailer = useIsLoggedInRetailer();
    return isLoggedInRetailer ? /*#__PURE__*/ _jsx(LoggedInLoginSection, {}) : /*#__PURE__*/ _jsx(LoggedOutLoginSection, {});
});
